import React, { useEffect, useState } from "react";
import workThumb from "../../assets/images/how-it-work-thumb.png";

function WorkPartHomeEight() {
  const [clubs, setClubs] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/clubstanding`, {
        method: "GET",
        headers: { Authorization: localStorage.getItem("auth") },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        setClubs(data);
      } else throw new Error(error);
    })().catch((error) => console.log(error.message));
  }, []);

  return (
    <div className="appie-how-it-work-area pt-140 pb-100">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <div className="how-it-work-thumb text-center">
              <img
                src={workThumb}
                alt=""
              />
            </div>
          </div>
          <div className="col-lg-8">
            <div className="appie-how-it-work-content">
              <h2 className="title">Club Standings</h2>
              <div className="row">
                {clubs.map((cl, ix) => (
                  <div
                    key={cl._id}
                    className="col-sm-6">
                    <div className="how-it-work-box">
                      <span>{ix + 1}</span>
                      <h5 className="title">
                        Club: {cl.name}
                        <br />
                        Points: {cl.points}
                      </h5>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkPartHomeEight;
